

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { Loading } from '../../../../../Helper/Loading'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { FinancialYearHeaderDDL } from '../../../../../Components/CommonDDL/FinancialYearHeaderDDL'
import { Get_T_ELE_KPI_DumpData_SelectAPI, Post_T_ELE_KPI_DumpData_InsertDataAPI } from '../../../../../Redux/ElectricalSlice/DailyElEDataFetchSlice'
import moment from 'moment'
import { FromReadingDayDDL } from '../../../../../Components/CommonDDL/FromReadingDayDDL'
import { ElEWorkNameDDL } from '../../../../../Components/CommonDDL/ElEWorkNameDDL'
import { MonthDataDDL } from '../../../../../Components/CommonDDL/MonthDataDDL'
import { DummyDataElectrical } from '../../../../../Helper/dummydata'
import { ExportDailyELEDataFetch } from './ExportDailyELEDataFetch'
import { BaseUrl } from '../../../../../Helper/BaseUrl'
import { toastErrorr, toastInfo } from '../../../../../Helper/ToastMessage'
import { VendorNameDDL } from '../../../../../Components/CommonDDL/VendorNameDDL'
import { FinancialYearFectData } from '../../../../../Components/CommonDDL/FinancialYearFectData'
import { MonthDataFetchDDL } from '../../../../../Components/CommonDDL/MonthDataFetchDDL'

export const DailyElEdataFetch = () => {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")


    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [IsLoading, setIsLoading] = useState(false)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [OpenCount, setOpenCount] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [FromDay, setFromDay] = useState('')
    const [ToDay, setToDay] = useState('')
    const [SelectData, setSelectData] = useState(1)

    const [tableData, settableData] = useState([])
    const [tableData1, settableData1] = useState([])
    const [tableData2, settableData2] = useState([])

    useEffect(() => {
        settableData(SelectData == 1 ? tableData1 : tableData2)
    }, [tableData1, tableData2, SelectData])

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [VendorName, setVendorName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })


    const [WorkName, setWorkName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [FinancialYearFetch, setFinancialYearFetch] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })
    const [MonthFetch, setMonthFetch] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })
    // const [ReadingFromDay, setReadingFromDay] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })
    // const [ReadingToDay, setReadingToDay] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })
    // const [FromDate, setFromDate] = useState()
    const [ReadingFromDay, setReadingFromDay] = useState()
    const [ReadingToDay, setReadingToDay] = useState()
    const [DesignationPopupShow, setDesignationPopupShow] = useState()
    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        if (SelectData == 1) {
            if (Month?.ID > 0 && FinancialYear?.Label && FinancialYear?.Label !== "Select...") {
                if (SelectData == 2) {
                    const calculatedMin = moment().subtract(2, 'days').format('YYYY-MM-DD');
                    const calculatedMax = moment().format('YYYY-MM-DD');
                    setMinDate(calculatedMin);
                    setMaxDate(calculatedMax);
                    setReadingFromDay(calculatedMin);
                    setReadingToDay(calculatedMax);
                } else {
                    const yearRange = FinancialYear.Label.split('-');
                    const selectedMonth = parseInt(Month.ID);

                    let year;
                    if (yearRange.length === 2) {
                        let rawYear = (selectedMonth >= 4) ? yearRange[0].trim() : yearRange[1].trim();

                        if (rawYear.length === 2) {
                            year = parseInt("20" + rawYear);
                        } else {
                            year = parseInt(rawYear);
                        }
                    } else {
                        year = parseInt(yearRange[0]) || moment().year();
                    }

                    const startOfMonth = moment([year, selectedMonth - 1, 1]);
                    const endOfMonth = moment(startOfMonth).endOf('month');
                    const today = moment();

                    const calculatedMin = startOfMonth.format('YYYY-MM-DD');
                    const calculatedMax = endOfMonth.isAfter(today) ? today.format('YYYY-MM-DD') : endOfMonth.format('YYYY-MM-DD');

                    setMinDate(calculatedMin);
                    setMaxDate(calculatedMax);

                    setReadingFromDay(calculatedMin);
                    setReadingToDay(calculatedMax);
                }
            }
        }
    }, [Month?.ID, FinancialYear?.ID, SelectData]);


    useEffect(() => {
        if (SelectData == 2) {
            if (MonthFetch?.ID > 0 && FinancialYearFetch?.Label && FinancialYearFetch?.Label !== "Select...") {
                if (SelectData == 2) {
                    const calculatedMin = moment().subtract(2, 'days').format('YYYY-MM-DD');
                    const calculatedMax = moment().format('YYYY-MM-DD');
                    setMinDate(calculatedMin);
                    setMaxDate(calculatedMax);
                    setReadingFromDay(calculatedMin);
                    setReadingToDay(calculatedMax);
                } else {
                    const yearRange = FinancialYearFetch.Label.split('-');
                    const selectedMonth = parseInt(MonthFetch.ID);

                    let year;
                    if (yearRange.length === 2) {
                        let rawYear = (selectedMonth >= 4) ? yearRange[0].trim() : yearRange[1].trim();

                        if (rawYear.length === 2) {
                            year = parseInt("20" + rawYear);
                        } else {
                            year = parseInt(rawYear);
                        }
                    } else {
                        year = parseInt(yearRange[0]) || moment().year();
                    }

                    const startOfMonth = moment([year, selectedMonth - 1, 1]);
                    const endOfMonth = moment(startOfMonth).endOf('month');
                    const today = moment();

                    const calculatedMin = startOfMonth.format('YYYY-MM-DD');
                    const calculatedMax = endOfMonth.isAfter(today) ? today.format('YYYY-MM-DD') : endOfMonth.format('YYYY-MM-DD');

                    setMinDate(calculatedMin);
                    setMaxDate(calculatedMax);

                    setReadingFromDay(calculatedMin);
                    setReadingToDay(calculatedMax);
                }
            }
        }
    }, [MonthFetch?.ID, FinancialYearFetch?.ID, SelectData]);


    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setDesignationPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setrowData(item)
        setDesignationPopupShow(true)
        setapiFlag('Update')
    }

    const handleOnCloseClick = () => {
        setDesignationPopupShow(false)
        handleIsPost()
    }



    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }



    const handleSearch = (IsClear) => {
        const data = {
            T_ELE_KPI_DumpDataID: '0',
            M_FinancialYearID: SelectData == 1 ? FinancialYear?.ID : FinancialYearFetch?.ID,
            M_MonthID: SelectData == 1 ? Month?.ID : MonthFetch?.ID,
            M_ELEC_WorkID: IsClear ? '0' : WorkName?.ID,
            M_WardID: IsClear ? '0' : WardName?.ID,
            M_Ward_Wise_VendorID: WardName?.ID == 2 ? VendorName?.ID : '0',
            StartDay:  ReadingFromDay ? moment(ReadingFromDay).format('DD') : '0',
            EndDay: ReadingToDay ? moment(ReadingToDay).format('DD') : '0',
            M_UserID: UserID,
            token: token,
            From: 1,
            To: 99999,
            settableData: SelectData == 1 ? settableData1 : settableData2
        }
        dispatch(Get_T_ELE_KPI_DumpData_SelectAPI({ data }))
    }

    const { isLoading } = useSelector(state => state.Get_T_ELE_KPI_DumpData_SelectData)


    const handleFetchData = () => {
        const data = {
            M_FinancialYearID: SelectData == 1 ? FinancialYear?.ID : FinancialYearFetch?.ID,
            M_MonthID: SelectData == 1 ? Month?.ID : MonthFetch?.ID,
            StartDay: ReadingFromDay ? moment(ReadingFromDay).format('DD') : '0',
            EndDay: ReadingToDay ? moment(ReadingToDay).format('DD') : '0',
            M_ELEC_WorkID: WorkName?.ID,
            M_WardID: WardName?.ID,
            ReadingDate: '',
            MiniPillerNo: '',
            TotalOffTimeInHour: '',
            TotalOnTimeInHour: '',
            PillerIsOpen: '',
            PFOcuranceCount: '',
            ReadingTime: '',
            R_C: '',
            Y_C: '',
            B_C: '',
            CalCurrent: '',
            PillerCurrentAmps: '',
            M_Ward_Wise_VendorID: WardName?.ID == 2 ? VendorName?.ID : '0',
            M_UserID: UserID,
            token: token,
            setLoading: setIsLoading,
            handleIsPost: handleIsPostSuccess
        }
        dispatch(Post_T_ELE_KPI_DumpData_InsertDataAPI({ data }))
    }

    const handleClear = () => {
        // setFinancialYear({
        //     ...FinancialYear,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        // setMonth({
        //     ...Month,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        setIsClear(true)
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setWorkName({
            ...WorkName,
            ID: 0,
            Label: 'Select...',
        })
        // setReadingFromDay({
        //     ...ReadingFromDay,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        // setReadingToDay({
        //     ...ReadingToDay,
        //     ID: 0,
        //     Label: 'Select...',
        // })
        handleSearch(true)
    }

    const handleIsPostSuccess = () => {
        handleSearch(false)
    }

    const days = Array.from({ length: 31 }, (_, i) =>
        String(i + 1).padStart(2, "0")
    );

    const handleOpenPdf = () => {

        let M_FinancialYearID = SelectData == 1 ? FinancialYear?.ID : FinancialYearFetch?.ID
        let M_MonthID = SelectData == 1 ? Month?.ID : MonthFetch?.ID

        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };
        setIsLoading(true)
        fetch(`${BaseUrl}/Electrical/Get_RM_DB_ELE_KPI_DumpDataFetchSelect?M_ELEC_WorkID=${WorkName?.ID}&M_WardID=${WardName?.ID}&M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_Ward_Wise_VendorID=${VendorName?.ID}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result?.code >= 200 && result?.code <= 300 && result?.status) {
                    window.open(result?.url)
                    setIsLoading(false)
                } else {
                    toastInfo(result?.message)
                    setIsLoading(false)
                }
            })
            .catch((error) => {
                toastErrorr(error)
                setIsLoading(false)
                console.error(error)
            });
    }

    return (
        <>
            {isLoading && <Loading />}
            {IsLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active="pole" listActive="DailyEleDataFet" />

                    <div id="" className="content1">
                        <div className="data_mob1">
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className='row col-12'>
                                    <div className='col-4'>
                                        <h5 className="ps-1 py-1">Daily Electrical Data
                                            {/* {`${RoleID == '43' || RoleID == '45' || RoleID == '46' ? 'Show' : 'Fetch'}`} */}
                                        </h5>
                                    </div>

                                    {
                                        (RoleID != '43' && RoleID != '45' && RoleID != '46') &&
                                        <div className="btn-group col-4 my-1" role="group" aria-label="Basic outlined example" >

                                            <button
                                                onClick={() => setSelectData(1)}
                                                className={SelectData == 1 ? "btn fw-bold px-4 activebutton text-white" : "text-black btn fw-bold px-4"}
                                                style={{ border: '1px solid #154779' }}
                                                type="button">
                                                Show Data
                                            </button>

                                            <button
                                                onClick={() => setSelectData(2)}
                                                className={SelectData == 2 ? "btn fw-bold px-4 activebutton text-white" : "text-black btn fw-bold px-4"}
                                                style={{ border: '1px solid #154779' }}
                                                type="button">
                                                Fetch Data
                                            </button>

                                        </div>
                                    }

                                    {
                                        (tableData && tableData?.length > 0) &&
                                        <>
                                            <div className="col-12 col-md-4 col-lg-4 ">
                                                {
                                                    SelectData == 1 &&
                                                    <ExportDailyELEDataFetch
                                                        ExcelData={tableData}
                                                        name="Daily Electrical Data"
                                                        WardName={WardName?.Label}
                                                        ReadingFromDay={ReadingFromDay}
                                                        ReadingToDay={ReadingToDay}
                                                        FinancialYear={FinancialYear?.Label}
                                                        Month={Month?.Label}
                                                    />
                                                }

                                                <button type="button"
                                                    disabled={IsLoading}
                                                    className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                                    onClick={handleOpenPdf}
                                                >Export PDF</button>
                                            </div>
                                        </>
                                    }

                                </div>




                                <div className="row m-0 ">

                                    <div className="col-12 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>

                                        <div className="col-12">


                                            <div className="row py-1 rounded2">
                                                {
                                                    SelectData == 1 ?
                                                        <>
                                                            <div className="col-12 col-md-4 col-lg-3">
                                                                <label for="" className=""><b>Financial Year</b></label>
                                                                <FinancialYearHeaderDDL
                                                                    FinancialYear={FinancialYear}
                                                                    setFinancialYear={setFinancialYear}
                                                                    // YLable={YLable}
                                                                    // HYear={HYear}
                                                                    flag='DailyData'
                                                                    col='10'
                                                                />
                                                            </div>
                                                            <div className="col-12 col-md-4 col-lg-3">
                                                                {/* <label for="" className=""><b>Month </b></label> */}
                                                                <MonthDataDDL
                                                                    Month={Month}
                                                                    setMonth={setMonth}
                                                                    screenType="DailyData"
                                                                    // MLable={MLable}
                                                                    // HMonth={HMonth}
                                                                    col='10'
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <>
                                                            <div className="col-12 col-md-4 col-lg-3">
                                                                <label for="" className=""><b>Financial Year</b></label>
                                                                <FinancialYearFectData
                                                                    FinancialYear={FinancialYearFetch}
                                                                    setFinancialYear={setFinancialYearFetch}
                                                                    // YLable={YLable}
                                                                    // HYear={HYear}
                                                                    // flag={flag}
                                                                    col='10'
                                                                />
                                                            </div>
                                                            <div className="col-12 col-md-4 col-lg-3">
                                                                {/* <label for="" className=""><b>Month </b></label> */}
                                                                <MonthDataFetchDDL
                                                                    Month={MonthFetch}
                                                                    setMonth={setMonthFetch}
                                                                    screenType="SearchFetch"
                                                                    // MLable={MLable}
                                                                    // HMonth={HMonth}
                                                                    // flag={flag}
                                                                    col='10'
                                                                />
                                                            </div>
                                                        </>
                                                }



                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard='0'
                                                        WLable=''
                                                        Type="Electrical"
                                                        APIFlag={(RoleID == 44 || RoleID == 45 || RoleID == 46) ? "UserWiseM_Ward" : "Master"}
                                                        IsPost={IsPost}
                                                        screenType="SearchFetch"
                                                    />
                                                </div>
                                                {
                                                    WardName?.ID == 2 &&
                                                    <div className="col-12 col-md-4 col-lg-3">
                                                        <VendorNameDDL
                                                            WardName={WardName}
                                                            VendorName={VendorName}
                                                            setVendorName={setVendorName}
                                                            APIFlag="Master"
                                                        />
                                                    </div>
                                                }

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <ElEWorkNameDDL
                                                        WorkType='0'
                                                        WorkSubType='0'
                                                        WorkNameType={WorkName}
                                                        setWorkNameType={setWorkName}
                                                        IsPost={IsPost}
                                                        isDisplay={true}
                                                        ApiFlag="Master"
                                                        screenType="SearchFetch"
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <label for="" className=""><b>From Reading Day</b></label>
                                                    <input
                                                        className='form-control'
                                                        type='date'
                                                        value={ReadingFromDay}
                                                        min={RoleID != 1 ? minDate : ''}
                                                        max={ReadingToDay || maxDate}
                                                        onChange={(e) => setReadingFromDay(e.target.value)}
                                                    />
                                                    {/* <FromReadingDayDDL
                                                        ReadingFromDay={ReadingFromDay}
                                                        setReadingFromDay={setReadingFromDay}
                                                    /> */}
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <label for="" className=""><b>To Reading Day</b></label>
                                                    <input
                                                        className='form-control'
                                                        type='date'
                                                        max={maxDate}
                                                        value={ReadingToDay}
                                                        min={ReadingFromDay || minDate}
                                                        onChange={(e) => setReadingToDay(e.target.value)}
                                                    />
                                                    {/* <FromReadingDayDDL
                                                        ReadingFromDay={ReadingToDay}
                                                        setReadingFromDay={setReadingToDay}
                                                    /> */}

                                                </div>

                                                <div className="col-12 col-md-3 col-lg-3 mt-4">
                                                    {/* <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" > */}

                                                    {
                                                        SelectData == 1 &&
                                                        <button type="button"
                                                            disabled={
                                                                FinancialYear?.ID == 0 ||
                                                                Month?.ID == 0 ||
                                                                WardName?.ID == 0 ||
                                                                WorkName?.ID == 0 ||
                                                                ReadingFromDay?.ID == 0 ||
                                                                ReadingToDay?.ID == 0
                                                            }
                                                            className="btn btn-primary px-4"
                                                            onClick={() => handleSearch(false)}
                                                        >
                                                            Search</button>
                                                    }


                                                    {
                                                        SelectData == 2 &&
                                                        <>
                                                            {
                                                                (RoleID != '43' && RoleID != '45' && RoleID != '46') &&

                                                                <button type="button"
                                                                    disabled={
                                                                        FinancialYearFetch?.ID == 0 ||
                                                                        MonthFetch?.ID == 0 ||
                                                                        WardName?.ID == 0 ||
                                                                        WorkName?.ID == 0 ||
                                                                        ReadingFromDay?.ID == 0 ||
                                                                        ReadingToDay?.ID == 0
                                                                    }
                                                                    className="btn btn-primary mx-2 px-4"
                                                                    onClick={handleFetchData}
                                                                >
                                                                    Fetch Data</button>
                                                            }
                                                        </>
                                                    }

                                                    <button type="button"
                                                        className="btn btn-danger ms-1 px-4"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>



                                            </div>


                                            <div className="row mob_table table-responsive pt-1" style={{ height: '81vh', overflow: 'scroll' }}>

                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered"
                                                    style={{ fontSize: '12px' }}
                                                >
                                                    <thead>
                                                        <tr >
                                                            <th align='center'>Sr.No.</th>
                                                            {/* <th align='center'>Reading Date</th> */}
                                                            <th align='center'>Work Name</th>
                                                            <th align='center'>Mini Piller No.</th>
                                                            <th align='center'>Phase</th>
                                                            <th align='center'>Reading Time</th>
                                                            {days.map(day => (
                                                                <th key={day}>{day}</th>
                                                            ))}
                                                            {/* <th>R_C</th>
                                                            <th>Y_C</th>
                                                            <th>B_C</th> */}
                                                            {/* <th>Avg. Sum</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData?.length > 0 ? tableData.map((pillar, Index) => {
                                                                const totalRows = pillar.phases.reduce(
                                                                    (sum, ph) => sum + ph.records.length,
                                                                    0
                                                                );

                                                                let pillarRendered = false;

                                                                return (
                                                                    <>
                                                                        {pillar.phases.map((phase, phIndex) => {
                                                                            let phaseRendered = false;

                                                                            return phase.records.map((record, rIndex) => (
                                                                                <tr key={`${Index}-${phIndex}-${rIndex}`} style={{ verticalAlign: 'middle' }}>
                                                                                    {/* Left fixed columns */}
                                                                                    {!pillarRendered && (
                                                                                        <>
                                                                                            <td rowSpan={totalRows} style={{ textAlign: "center" }}>{Index + 1}</td>
                                                                                            {/* <td rowSpan={totalRows} style={{ textAlign: "center", whiteSpace: 'nowrap' }}>{pillar.readingDay ? moment(pillar.readingDay).format('DD-MM-YYYY') : "-"}</td> */}
                                                                                            <td rowSpan={totalRows} style={{ textAlign: "center" }}>{pillar?.workName || "-"}</td>
                                                                                            <td rowSpan={totalRows} style={{ textAlign: "center" }}>{pillar?.miniPillarNo}</td>
                                                                                        </>
                                                                                    )}

                                                                                    {/* Phase column */}
                                                                                    {!phaseRendered && (
                                                                                        <td rowSpan={phase.records.length} style={{ textAlign: "center" }}>
                                                                                            {phase.phase}
                                                                                        </td>
                                                                                    )}

                                                                                    {/* Time */}
                                                                                    <td>{record.time}</td>

                                                                                    {/* Day values */}
                                                                                    {days.map(day => (
                                                                                        <td key={day} style={{ textAlign: "center" }}>{record.days[day]}</td>
                                                                                    ))}

                                                                                    {/* Right summary columns */}
                                                                                    {/* {!pillarRendered && (
                                                                                        <>
                                                                                            <td rowSpan={totalRows}>{pillar.summary.benchmarkMax}</td>
                                                                                            <td rowSpan={totalRows}>
                                                                                                {pillar.summary.min}
                                                                                                <hr style={{ margin: '0px' }} />
                                                                                                {pillar.summary.max}
                                                                                            </td>
                                                                                            <td rowSpan={totalRows}>{pillar.summary.defaulterAmp}</td>
                                                                                            <td rowSpan={totalRows}>{pillar.summary.unitPenalty}</td>
                                                                                            <td rowSpan={totalRows}>{pillar.summary.totalPenalty}</td>
                                                                                        </>
                                                                                    )} */}

                                                                                    {pillarRendered = true}
                                                                                    {phaseRendered = true}
                                                                                </tr>
                                                                            ));
                                                                        })}


                                                                        {/* ================= AVGSUM ROW ================= */}
                                                                        {/* < tr >
                                                                            <td colSpan={5}></td>
                                                                            <td colSpan={0}><b>AvgSum</b></td>

                                                                            {days.map(day => (
                                                                                <td key={day}><b>{pillar?.avgSum?.[day]}</b></td>
                                                                            ))}



                                                                            <td colSpan={0}></td>
                                                                            <td colSpan={0}></td>
                                                                            <td colSpan={0}></td>
                                                                            <td colSpan={0}></td>
                                                                            <td colSpan={0}></td>

                                                                        </tr> */}

                                                                        {/* ================= DEFAULTER ROW ================= */}
                                                                        {/* <tr>
                                                                            <td colSpan={5}></td>
                                                                            <td colSpan={0}><b>Defaulter</b></td>

                                                                            {days.map(day => (
                                                                                <td key={day}><b>{pillar?.defaulterDays?.[day]}</b></td>
                                                                            ))}

                                                                            {
                                                                                pillar?.defaulterSummary && pillar?.defaulterSummary?.length > 0 && pillar?.defaulterSummary.map(i => {
                                                                                    return (
                                                                                        <>
                                                                                            <td colSpan={0}><b>{i?.benchmarkMax}</b></td>
                                                                                            <td colSpan={0}><b>{i?.minmax}</b></td>
                                                                                            <td colSpan={0}><b>{i?.defaulterAmp}</b></td>
                                                                                            <td colSpan={0}><b>{i?.unitPenalty}</b></td>
                                                                                            <td colSpan={0}><b>{i?.totalPenalty}</b></td>
                                                                                        </>
                                                                                    )
                                                                                })
                                                                            }


                                                                        </tr> */}
                                                                    </>
                                                                );
                                                            })
                                                                :
                                                                <tr>
                                                                    <td colSpan={42}>No Data Found...</td>
                                                                </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            } */}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* {
                    DesignationPopupShow ?
                        <WardWiseTokenModal
                            open={DesignationPopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                } */}




        </>
    )
}